import { render, staticRenderFns } from "./BagkurEmekliDetay.vue?vue&type=template&id=bbe0e368&scoped=true"
import script from "./BagkurEmekliDetay.vue?vue&type=script&lang=ts"
export * from "./BagkurEmekliDetay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe0e368",
  null
  
)

export default component.exports